/** @graphql cc **/

import gql from 'graphql-tag';

export const DatabaseValueContainerContentUnifiedQuery = gql`
	query DatabaseValueContainerContentUnifiedQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				referenceId
				space {
					id
					key
					name
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
			emails {
				value
				isPrimary
			}
			locale
		}
	}
`;
